/**
 * Plain-language availability for a table card / invite (rejoin list and the
 * invite notifier). Pure so it can be unit-tested.
 */

export type SeatState = 'online' | 'offline' | 'joined' | 'rejoined' | 'left';

export interface RoomStatus {
  /** e.g. "3 of 4 seated" */
  seats: string;
  /** short tag text */
  tag: string;
  tone: 'open' | 'full';
  /** players currently connected (online / joined / rejoined) */
  here: number;
}

const PRESENT: SeatState[] = ['online', 'joined', 'rejoined'];

export const roomStatus = ({
  numberOfPlayers,
  isFull,
  users = [],
}: {
  numberOfPlayers: number;
  isFull: boolean;
  users?: { state?: SeatState }[];
}): RoomStatus => {
  const seated = users.filter(u => u.state !== 'left').length;
  const total = Math.max(numberOfPlayers || 0, seated);
  const full = isFull || (total > 0 && seated >= total);
  return {
    seats: total ? `${seated} of ${total} seated` : `${seated} seated`,
    tag: full ? 'Game on' : `${Math.max(total - seated, 0)} open`,
    tone: full ? 'full' : 'open',
    here: users.filter(u => u.state && PRESENT.includes(u.state)).length,
  };
};

/** Invite availability: a full table can't be accepted. */
export const inviteStatus = (room: {
  numberOfPlayers: number;
  isFull: boolean;
}) =>
  room.isFull
    ? { label: 'Table full', canAccept: false }
    : { label: `${room.numberOfPlayers}-player table · seats open`, canAccept: true };
